import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { isEqual } from 'lodash';
import { useTranslation } from 'next-i18next';
import { Select, selectCustomStyles } from '../../../../../primitives/Select/index.js';
export const FilterDropdown = ({
  value,
  options,
  isMulti,
  onChange
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  const mdUp = useBreakpointUp('md');
  const prefix = mdUp ? t('amadeusRatingSection.filters.prefix') : '';
  return _jsx(Select, {
    fullWidth: true,
    options: options,
    value: options.filter(option => value.includes(option.value)),
    isSearchable: false,
    isMulti: isMulti,
    isClearable: false,
    hideSelectedOptions: false,
    menuShouldScrollIntoView: false,
    highlightBehaviour: "always",
    placeholder: t('amadeusRatingSection.filters.placeholder'),
    formatSingleValue: state => ({
      prefix,
      value: state.data.label
    }),
    multiValuePrefix: prefix,
    isOptionDisabled: (_option, _selectedOptions) => {
      const option = _option;
      const selectedOptions = _selectedOptions;
      // these two options are mutually exclusive
      const withRecommendationSelected = selectedOptions.some(selectedOption => selectedOption.value === 'withRecommendation');
      const withoutRecommendationSelected = selectedOptions.some(selectedOption => selectedOption.value === 'withoutRecommendation');
      return option.value === 'withRecommendation' && withoutRecommendationSelected || option.value === 'withoutRecommendation' && withRecommendationSelected || false;
    },
    styles: {
      menu: (...args) => ({
        ...selectCustomStyles.menu(...args),
        width: mdUp ? '100%' : '150%'
      })
    },
    onBlur: event => {
      // This prevents radix-ui stealing focus from us and moving it to the wrapping dialog.
      // @FIXME this workaround should be removed once we have a better solution (ie. no "solution" at all, this should "just work").
      if (event.relatedTarget instanceof HTMLElement) {
        event.relatedTarget?.focus();
      }
    },
    onChange: optionOrListOfOptions => {
      const nextValue = (Array.isArray(optionOrListOfOptions) ? optionOrListOfOptions : [optionOrListOfOptions]).map(option => option.value);
      // Sometimes "onChange" gets called even though nothing has actually changed,
      // so we need another check to avoid unnecessary updates.
      // To reproduce:
      // - focus select with tab
      // - press space to open it
      // - press tab to close it (related is react-selects "tabSelectsValue" option)
      if (!isEqual(nextValue, value)) {
        onChange(nextValue);
      }
    }
  });
};